"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = More;
var _More = require("@adobe/react-spectrum-workflow/dist/More.js");
var _icon = require("@react-spectrum/icon");
var _react = _interopRequireDefault(require("react"));
function More(props) {
  return /*#__PURE__*/_react.default.createElement(_icon.Icon, props, /*#__PURE__*/_react.default.createElement(_More.A4uMore, null));
}